var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('path',{staticClass:"body-path",staticStyle:{"stroke-width":"13.75px"},attrs:{"id":"body-path","d":_vm.bodyPath}})}
var staticRenderFns = []

export { render, staticRenderFns }